/**
 * Environment variable accessor
 * Provides type-safe access to environment variables
 */

interface Env {
    apiBaseUrl: string
    apiTimeout: number
    appName: string
    isDevelopment: boolean
    isProduction: boolean
    qrEncryptionKey: string // Deprecated: kept for backward compatibility
    totpSecret: string
    adminPassword: string
    adminGodPassword: string
}

export const env: Env = {
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
    apiTimeout: Number(import.meta.env.VITE_API_TIMEOUT) || 30000,
    appName: 'Warden',
    isDevelopment: import.meta.env.DEV,
    isProduction: import.meta.env.PROD,
    qrEncryptionKey: import.meta.env.VITE_QR_ENCRYPTION_KEY || '', // Deprecated
    totpSecret: import.meta.env.VITE_TOTP_SECRET || '',
    adminPassword: import.meta.env.VITE_ADMIN_PASSWORD || '',
    adminGodPassword: import.meta.env.VITE_ADMIN_GOD_PASSWORD || ''
}
